import React, { PureComponent } from "react";
import HelpIconButtonWithTooltipAndTypeformModal from "../../../typeform/HelpIconButtonWithTooltipAndTypeformModal";
import HorizontalBarChart from "../../../ceo/analysis/competitive/charts/horizontal-bar";
import VerticalBarChart from "../../../ceo/analysis/competitive/charts/vertical-bar";
import TypeformContent from "../../../typeform/TypeformContent";

class Kpis1 extends PureComponent {
  getDataValue = (team_id, key) => {
    const { data } = this.props;

    if (!(team_id in data)) {
      return 0;
    }

    if (!(key in data[team_id])) {
      return 0;
    }

    const val = data[team_id][key];

    if (!val) {
      return 0;
    }

    return val;
  };

  get MarketShare() {
    const { teams, metrics } = this.props;
    let data = [];

    Object.keys(teams).forEach(team_id => {
      const team = teams[team_id];
      data.push({
        name: team,
        value:
          metrics[team_id] && metrics[team_id]["MarketShare"]
            ? metrics[team_id]["MarketShare"] * 100
            : 0
      });
    });

    return data;
  }

  get GrossMargins() {
    const { teams, metrics } = this.props;
    let data = [];

    Object.keys(teams).forEach(team_id => {
      const team = teams[team_id];
      data.push({
        name: team,
        value:
          metrics[team_id] && metrics[team_id]["GrossMargins"]
            ? metrics[team_id]["GrossMargins"] * 100
            : 0
      });
    });

    return data;
  }

  get Revenues() {
    const { teams, metrics } = this.props;
    let data = [];

    Object.keys(teams).forEach(team_id => {
      const team = teams[team_id];
      data.push({
        name: team,
        value:
          metrics[team_id] && metrics[team_id]["Revenues"]
            ? metrics[team_id]["Revenues"] / 1000000
            : 0
      });
    });

    return data;
  }

  get SharePrice() {
    const { teams } = this.props;
    let data = [];

    Object.keys(teams).forEach(team_id => {
      const team = teams[team_id];
      data.push({
        name: team,
        value: this.getDataValue(team_id, "Share Price")
      });
    });

    return data;
  }

  render() {
    return (
      <div className="row">
        <div className="col-md-3 col-xs-12">
          <div className="bg-white p-30">
            <HorizontalBarChart suffix="%" data={this.MarketShare} />
            <div className="text-center" style={{ marginTop: "-20px" }}>
              Market Share
            </div>
          </div>
        </div>
        <div className="col-md-3 col-xs-12">
          <div className="bg-white p-30">
            <VerticalBarChart
              prefix="$"
              suffix="M"
              precision={3}
              data={this.Revenues}
            />
            <div className="text-center" style={{ marginTop: "-20px" }}>
              Revenues
            </div>
          </div>
        </div>
        <div className="col-md-3 col-xs-12">
          <div className="bg-white p-30">
            <VerticalBarChart suffix="%" data={this.GrossMargins} />
            <div className="text-center" style={{ marginTop: "-20px" }}>
              Gross Margins
            </div>
          </div>
        </div>
        <div className="col-md-3 col-xs-12">
          <div className="bg-white p-30">
            <HorizontalBarChart prefix="$" data={this.SharePrice} />
            <div className="text-center" style={{ marginTop: "-20px" }}>
              Share Price
              <HelpIconButtonWithTooltipAndTypeformModal
                iconSize="xs"
                {...TypeformContent.STOCK_PRICE}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Kpis1;



// WEBPACK FOOTER //
// ./src/components/ceo/analysis/competitive/kpis-1.js